const Intro = () => {
    return (
        <div className="mt-20">
            <div className="text-6xl dark:text-title-color text-title-color-dark 576:text-3xl">
                Dima Rybak
            </div>
            <div className="text-[40px] dark:text-subtitle-color text-subtitle-color-dark 576:text-2xl">
                Hello. I'm Backend Developer based in Poland
            </div>
        </div>
    )
}

export default Intro
